var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject } from 'aurelia-framework';
import { Api } from '../../../constants/modules/api.constants';
import { RequestClient } from '../../basics/request-client.service';
import { LotteryClientService } from '../lottery-client.service';
import { ConfigClientService } from '../client-config.service';
import { BrandingType, TemplateType } from '../brand-client.service';
import { toNative, toNativeVoid } from '../../../utilities/promise-utils';
var ClientLotteryClientService = /** @class */ (function () {
    function ClientLotteryClientService(requestClient, configClientService, lotteryClientService) {
        this.requestClient = requestClient;
        this.configClientService = configClientService;
        this.lotteryClientService = lotteryClientService;
        this.nextDrawCache = {};
        this.brandLotterySyndicatesCache = {};
        this.brandLotterySyndicatesPromise = {};
        this.getClientLotteryPromise = {};
        this.getClientInstantGamePromise = {};
        this.getClientBundlePromise = {};
        this.getClientSyndicatePromise = {};
        this.getClientLotteryCache = {};
        this.getClientInstantGameCache = {};
        this.getClientBundleCache = {};
        this.getClientSyndicateCache = {};
    }
    ClientLotteryClientService.prototype.getLotteryAdditionalInfo = function (lotteryId) {
        return toNative(this.requestClient.get("".concat(Api.Client.GetLotteryAdditionalInfo, "/").concat(lotteryId), {}));
    };
    ClientLotteryClientService.prototype.getLobbyBrandLotteries = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.lobbyBrandLotteriesCache)
                resolve(_this.lobbyBrandLotteriesCache);
            else if (_this.getLobbyBrandLotteriesPromise)
                _this.getLobbyBrandLotteriesPromise.then(resolve, reject);
            else
                _this.getLobbyBrandLotteriesPromise = toNative(_this.requestClient.get(Api.Client.GetLobbyBrandLotteries, request));
            _this.getLobbyBrandLotteriesPromise.then(function (x) {
                _this.lobbyBrandLotteriesCache = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getLobbyBrandInstantGames = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.lobbyBrandInstantGamesCache)
                resolve(_this.lobbyBrandInstantGamesCache);
            else if (_this.getLobbyBrandInstantGamesPromise)
                _this.getLobbyBrandInstantGamesPromise.then(resolve, reject);
            else
                _this.getLobbyBrandInstantGamesPromise = toNative(_this.requestClient.get(Api.Client.GetLobbyBrandInstantGames, request));
            _this.getLobbyBrandInstantGamesPromise.then(function (x) {
                _this.lobbyBrandInstantGamesCache = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getLobbyBrandScratchcards = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.lobbyBrandScratchcardsCache)
                resolve(_this.lobbyBrandScratchcardsCache);
            else if (_this.getLobbyBrandScratchcardsPromise)
                _this.getLobbyBrandScratchcardsPromise.then(resolve, reject);
            else
                _this.getLobbyBrandScratchcardsPromise = toNative(_this.requestClient.get(Api.Client.GetLobbyBrandScratchcards, request));
            _this.getLobbyBrandScratchcardsPromise.then(function (x) {
                _this.lobbyBrandScratchcardsCache = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getLobbyBundles = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.lobbyBundlesCache && !request.getIsPromotionBundles)
                resolve(_this.lobbyBundlesCache);
            else if (_this.lobbyPromotionBundlesCache && request.getIsPromotionBundles)
                resolve(_this.lobbyPromotionBundlesCache);
            else if (_this.getLobbyBundlesPromise && !request.getIsPromotionBundles)
                _this.getLobbyBundlesPromise.then(resolve, reject);
            else if (_this.getLobbyPromotionBundlesPromise && request.getIsPromotionBundles)
                _this.getLobbyPromotionBundlesPromise.then(resolve, reject);
            else {
                var requestPromise = toNative(_this.requestClient.get(Api.Client.GetLobbyBundles, request));
                if (request.getIsPromotionBundles)
                    _this.getLobbyPromotionBundlesPromise = requestPromise;
                else
                    _this.getLobbyBundlesPromise = requestPromise;
            }
            var promise = request.getIsPromotionBundles ? _this.getLobbyPromotionBundlesPromise : _this.getLobbyBundlesPromise;
            promise.then(function (x) {
                if (request.getIsPromotionBundles)
                    _this.lobbyPromotionBundlesCache = x;
                else
                    _this.lobbyBundlesCache = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getBrandLotterySyndicates = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.brandLotterySyndicatesCache[request.brandLotteryId])
                resolve(_this.brandLotterySyndicatesCache[request.brandLotteryId]);
            else if (_this.brandLotterySyndicatesPromise[request.brandLotteryId])
                _this.brandLotterySyndicatesPromise[request.brandLotteryId].then(resolve, reject);
            else
                _this.brandLotterySyndicatesPromise[request.brandLotteryId] = toNative(_this.requestClient.get(Api.Client.GetBrandLotterySyndicates, request));
            _this.brandLotterySyndicatesPromise[request.brandLotteryId].then(function (x) {
                _this.brandLotterySyndicatesCache[request.brandLotteryId] = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getLobbyLatestResults = function (request) {
        return toNative(this.requestClient.get(Api.Client.GetLobbyLatestResults, request));
    };
    ClientLotteryClientService.prototype.refreshFreeTicketCount = function (brandLotteryId) {
        return toNative(this.requestClient.get(Api.Client.GetClientLottery, { brandLotteryId: brandLotteryId }))
            .then(function (x) { return x ? (x.freeTicketCount || 0) : 0; });
    };
    ClientLotteryClientService.prototype.getClientLottery = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.getClientLotteryCache[request.lotteryId])
                resolve(_this.getClientLotteryCache[request.lotteryId]);
            else if (_this.getClientLotteryPromise[request.lotteryId])
                _this.getClientLotteryPromise[request.lotteryId].then(resolve, reject);
            else
                _this.getClientLotteryPromise[request.lotteryId] = toNative(_this.requestClient.get(Api.Client.GetClientLottery, request));
            _this.getClientLotteryPromise[request.lotteryId].then(function (x) {
                _this.getClientLotteryCache[x.lotteryId] = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getInstantGameUserPlayInfo = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var promise = _this.requestClient.get(Api.Client.GetInstantGameUserPlayInfo, request);
            promise.then(function (x) {
                resolve(x.instantGamePlayerInformation);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.markTransactionAsEnded = function (transactionId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var promise = _this.requestClient.post(Api.Client.MarkTransactionAsComplete, { transactionId: transactionId });
            promise.then(function (x) {
                resolve();
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getClientInstantGame = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.getClientInstantGameCache[request.instantGameId])
                resolve(_this.getClientInstantGameCache[request.instantGameId]);
            else if (_this.getClientInstantGamePromise[request.instantGameId])
                _this.getClientInstantGamePromise[request.instantGameId].then(resolve, reject);
            else
                _this.getClientInstantGamePromise[request.instantGameId] = toNative(_this.requestClient.get(Api.Client.GetClientInstantGame, request));
            _this.getClientInstantGamePromise[request.instantGameId].then(function (x) {
                _this.getClientInstantGameCache[x.instantGameId] = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getClientBundle = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.getClientBundleCache[request.bundleId])
                resolve(_this.getClientBundleCache[request.bundleId]);
            else if (_this.getClientBundlePromise[request.bundleId])
                _this.getClientBundlePromise[request.bundleId].then(resolve, reject);
            else
                _this.getClientBundlePromise[request.bundleId] = toNative(_this.requestClient.get(Api.Client.GetClientBundle, request));
            _this.getClientBundlePromise[request.bundleId].then(function (x) {
                _this.getClientBundleCache[x.bundleId] = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getClientSyndicate = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.getClientSyndicateCache[request.syndicateId])
                resolve(_this.getClientSyndicateCache[request.syndicateId]);
            else if (_this.getClientSyndicatePromise[request.syndicateId])
                _this.getClientSyndicatePromise[request.syndicateId].then(resolve, reject);
            else
                _this.getClientSyndicatePromise[request.syndicateId] = toNative(_this.requestClient.get(Api.Client.GetClientSyndicate, request));
            _this.getClientSyndicatePromise[request.syndicateId].then(function (x) {
                _this.getClientSyndicateCache[x.syndicateId] = x;
                resolve(x);
            }, reject);
        });
    };
    ClientLotteryClientService.prototype.getMyPurchases = function (page, transactionId, filter, lotteryId) {
        return toNative(this.requestClient.get(Api.Client.GetMyPurchases + '/' + page, { transactionId: transactionId, filter: filter, lotteryId: lotteryId }));
    };
    ClientLotteryClientService.prototype.getAgentWinningClaims = function (page, filter, dateFrom) {
        return toNative(this.requestClient.post(Api.Client.GetAgentWinningClaims + '/' + page, {}, { filter: filter, dateFrom: dateFrom }));
    };
    ClientLotteryClientService.prototype.getNextDraw = function (lotteryId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.nextDrawCache[lotteryId]) {
                resolve(_this.nextDrawCache[lotteryId]);
            }
            else {
                _this.requestClient.get(Api.Client.GetNextDraw + '/' + lotteryId, {}).then(function (success) {
                    _this.nextDrawCache[lotteryId] = success;
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            }
        });
    };
    ClientLotteryClientService.prototype.changeWinningClaimPayoutStatus = function (winningClaimId, id) {
        return toNativeVoid(this.requestClient.post(Api.Client.ChangeWinningClaimPayoutStatus, {}, {
            winningClaimId: winningClaimId,
            statusId: id
        }));
    };
    ClientLotteryClientService.prototype.getResultsBrandLotteries = function (request) {
        return toNative(this.requestClient.get(Api.Client.GetResultsBrandLotteries, request));
    };
    ClientLotteryClientService.prototype.getResultsLatestResults = function (request) {
        return toNative(this.requestClient.get(Api.Client.GetResultsLatestResults, request));
    };
    ClientLotteryClientService.prototype.getCarouselLotteryKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonLobby, lobby, carouselLotteriesArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Lobby)];
                    case 1:
                        jsonLobby = _a.sent();
                        lobby = jsonLobby[TemplateType.Lobby];
                        carouselLotteriesArray = lobby ? lobby[BrandingType.CarouselLotteries] : [];
                        return [2 /*return*/, carouselLotteriesArray ? carouselLotteriesArray.filter(function (x) { return x.isVisible !== false; }).map(function (x) { return x.key; }) : []];
                }
            });
        });
    };
    ClientLotteryClientService.prototype.getCarouselScratchcardKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonLobby, lobby, carouselScratchcardsArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Lobby)];
                    case 1:
                        jsonLobby = _a.sent();
                        lobby = jsonLobby[TemplateType.Lobby];
                        carouselScratchcardsArray = lobby ? lobby[BrandingType.CarouselScratchcards] : [];
                        return [2 /*return*/, carouselScratchcardsArray ? carouselScratchcardsArray.filter(function (x) { return x.isVisible !== false; }).map(function (x) { return x.key; }) : []];
                }
            });
        });
    };
    ClientLotteryClientService.prototype.getCarouselInstantGameCardsKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonLobby, lobby, carouselScratchcardsArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Lobby)];
                    case 1:
                        jsonLobby = _a.sent();
                        lobby = jsonLobby[TemplateType.Lobby];
                        carouselScratchcardsArray = lobby ? lobby[BrandingType.InstantGameCards] : [];
                        return [2 /*return*/, carouselScratchcardsArray ? carouselScratchcardsArray.filter(function (x) { return x.isVisible !== false; }).map(function (x) { return x.key; }) : []];
                }
            });
        });
    };
    ClientLotteryClientService.prototype.getOverlayFeaturedKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonOverlay, overlay, overlayLotteriesArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Overlay)];
                    case 1:
                        jsonOverlay = _a.sent();
                        overlay = jsonOverlay[TemplateType.Overlay];
                        overlayLotteriesArray = overlay ? overlay[BrandingType.Featured] : [];
                        return [2 /*return*/, overlayLotteriesArray ? overlayLotteriesArray.filter(function (x) { return x.isVisible !== false; }).map(function (x) { return x.key; }) : []];
                }
            });
        });
    };
    ClientLotteryClientService.prototype.getQuickPlayKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonLobby, lobby, quickPlayLotteriesArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Lobby)];
                    case 1:
                        jsonLobby = _a.sent();
                        lobby = jsonLobby[TemplateType.Lobby];
                        quickPlayLotteriesArray = lobby ? lobby[BrandingType.QuickPlay] : [];
                        return [2 /*return*/, quickPlayLotteriesArray ? quickPlayLotteriesArray.filter(function (x) { return x.isVisible !== false; }).map(function (x) { return x.key; }) : []];
                }
            });
        });
    };
    ClientLotteryClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, ConfigClientService, LotteryClientService])
    ], ClientLotteryClientService);
    return ClientLotteryClientService;
}());
export { ClientLotteryClientService };
